import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { MyNotesNoteTemplatePropsInterface } from 'common/module/my-notes/note/template-props.interface';
import { TextTrimComponent } from 'common/module/text-trim/component';

export const MyNotesNoteTemplate: FunctionalComponent<MyNotesNoteTemplatePropsInterface> = (props) => (
  <div className='note'>
    <div className='note__title'>{i18nTranslate('My note')}</div>
    <TextTrimComponent
      className={`note__description ${props.isExpanded ? 'note__description--expanded' : ''}`}
      onTrim={props.onTrim}
    >
      {props.model.description}
    </TextTrimComponent>
    <div className='note__action-buttons'>
      <div>
        {props.isReadMoreVisible && !props.isExpanded && (
          <div className='note__description-button' key='read-more-button' onClick={props.onClickReadMore}>
            {i18nTranslate('Read more')}
            <span
              className='svg'
              dangerouslySetInnerHTML={{
                __html: `
                <svg viewBox='0 0 13 8' class='note__description-button-icon'>
                  <use xlink:href='#svg-chevron-down'></use>
                </svg>
              `,
              }}
            />
          </div>
        )}
        {props.isExpanded && (
          <div className='note__description-button' key='read-less-button' onClick={props.onClickReadLess}>
            {i18nTranslate('Read less')}
            <span
              className='svg'
              dangerouslySetInnerHTML={{
                __html: `
                <svg viewBox='0 0 13 8' class='note__description-button-icon'>
                  <use xlink:href='#svg-chevron-up'></use>
                </svg>
              `,
              }}
            />
          </div>
        )}
      </div>
      {props.isShowDeleteButton && (
        <div className='note__delete-button' key='delete-button' onClick={() => props.onClickDelete(props.model)}>
          <span
            className='svg'
            dangerouslySetInnerHTML={{
              __html: `
              <svg viewBox='0 0 10 12' class='note__delete-button-icon'>
                <use xlink:href='#svg-trash'></use>
              </svg>
            `,
            }}
          />
          {i18nTranslate('Delete')}
        </div>
      )}
    </div>
  </div>
);
